import { BaseDto, FileDto } from '../index'
import { BaseError } from '../../errors'

export interface TranslationObject {
  en: string | null
  kh?: string | null
}

export interface OfflineTenantBookingTranslation {
  languageCode: string
  name: string
  description?: string
  operatingHour?: string
  contact?: string
}

export interface TenantBookingImageDto {
  id: string
  imageId: string
  image: FileDto
}

export interface TenantBookingTimeSlotDto {
  id?: string
  fromTime: string
  toTime: string
  slots: number
  enabled: boolean
}

export class TenantBookingDto extends BaseDto {
  tenantId?: string

  translations?: OfflineTenantBookingTranslation[]
  name?: TranslationObject
  description?: TranslationObject
  operatingHour?: TranslationObject
  contact?: TranslationObject
  email?: TranslationObject
  enabled?: boolean
  displayOrder?: number
  
  bookingEnabled?: boolean
  bookingPickup?: boolean
  bookingStay?: boolean

  images?: TenantBookingImageDto[]
  slots?: TenantBookingTimeSlotDto[]
  
  logo?: FileDto
  storeListingImage?: FileDto
  featureImage?: FileDto
  
  deeplink?: string
  numberOfFavourites?: number
  offlineCategoryId?: string
  mallId?: string
  floorId?: string
  
  mall?: {
    id: string
    name: TranslationObject
  }
  offlineTenantCategory?: {
    id: string
    name: TranslationObject
  }
  owners?: Array<{
    id: string
    fullName: string
    email: string
    gender?: string | null
    enabled: boolean
    photo?: string | null
    phoneNumber?: string | null
    roleNames: string[]
  }>

  static create({ id, name, enabled, displayOrder, translations }: Partial<TenantBookingDto>) {
    return Object.assign(new TenantBookingDto(), {
      id: id || null,
      name: name || { en: '', kh: '' },
      enabled: enabled || false,
      displayOrder: displayOrder || 0,
      translations: translations || [],
      bookingPickup: false,
      bookingStay: false,
      images: [],
      slots: [],
      numberOfFavourites: 0,
      owners: []
    })
  }

  static update() {
    return new TenantBookingDto()
  }
}

export class UpdateTenantBookingDto {
  bookingEnabled?: boolean
  bookingPickup?: boolean
  bookingStay?: boolean
  imageIds?: string[]
  destroyImageIds?: string[]
}

export class CreateSlotsDto {
  slots: TenantBookingTimeSlotDto[]
}

export class UpdateSlotStatusDto {
  enabled: boolean
}

export interface TenantBookingFilters {
  search: string
  bookingEnabled: boolean | null
}

export interface TenantBookingState {
  tenantBookings: TenantBookingDto[]
  isLoading: boolean
  error: BaseError | null
  pageInfo: {
    page: number
    pageSize: number
    collectionSize: number
    from: number
    to: number
  }
  filters: TenantBookingFilters
  lastUpdated: Date | null
}